import React, { useState } from "react";
import close from "../../../../src/static/ic-close.svg";
import { withTranslation, Trans } from "react-i18next";

import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { get_accessToken, get_bankIdentifierCode, get_bankName, get_internationalBankAccountNumber, get_LeftRight } from "../../../helper/UserData/userdate";
import { Api_Get_AcountInformation_AGW } from "../../../helper/api/ApiGateway";
import { ReactComponent as ChangePassword } from "../../../../src/static/Change-Password.svg";
import {ReactComponent as withdraw_email_document} from "../../../../src/static/IconProvider/withdraw/ic_back.svg";
import { Bussiness_change_password } from "../../../helper/api";
import IconProviderSvgModifier from "../../../design-system/lib/IconProviderSvgModifier";
import { SucceessFul_i18 } from "../../../helper/Notification/sendNotification";
import { httpCustomer } from "../../../service/api/axios";
import { snack } from "../../../helper/module/SnackbarUtilsConfigurator";
import { Customer_Edit_AccountInformation_Action } from "../../../Redux/actions/actions";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      BankName: get_bankName() || "",
      BankCode:  get_bankIdentifierCode() || "",
      AccountNumber: get_internationalBankAccountNumber() || "",
    };
    this.saveChangePassword = this.saveChangePassword.bind(this)
  }

  handleShowForm() {
    this.setState({
      showForm: true,
    });
  }

  openOrderHistory = () => {
    this.setState({
      showForm: false,
    });
  };

  inputOnchange(key, val) {
    this.setState({
      [key]: val,
    });
  }

  saveChangePassword() {


            var bodyFormData = new FormData();
            bodyFormData.append("bankName", this.state.BankName);
                 bodyFormData.append("bankIdentifierCode", this.state.BankCode);
            bodyFormData.append("internationalBankAccountNumber", this.state.AccountNumber);

           this.props.dispatch(
             Customer_Edit_AccountInformation_Action(this.props.dispatch, bodyFormData, (data)=>{
              //call({ res, loading: false, error: false })
              snack.success(this.props.t("SucceessFul"))
             })
           );
         

                  this.setState({
      showForm: false,
    });
   }

  render() {
    let canSave =
      String(this.state.BankName) && String(this.state.BankName).length > 0 && String(this.state.AccountNumber) && String(this.state.AccountNumber).length > 0  && String(this.state.BankCode) && String(this.state.BankCode).length > 0  ;
    return (
      <>
        <div
          className={`PhoneNumberContainer ${this.state.numberNotRegistered && "PhoneNumberContainerError"
            }`}
          style={{ height: "32px", borderRadius: "8px", marginTop: "0px" ,marginBottom:"12px" }}
          onClick={() => this.handleShowForm()}
        >
          <span
            onClick={this.handleOpen}
            className={`langContainer`}
            style={{ paddingTop: "8px" }}
          >
            <div className="SignOutContainer">
              {/* <ChangePassword className="SignOut ChangePasswordicon" /> */}
              <IconProviderSvgModifier Icon={withdraw_email_document} size="20" style={{float:"inline-start" , width :"20px"}} className={"ChangePasswordicon"} />
              <span className="LogoutText">
                {" "}
                <Trans i18nKey={"Bank acccount"}> </Trans>
              </span>
            </div>
          </span>
        </div>

        <Slide
          timeout={650}
          direction={get_LeftRight()}
          in={this.state.showForm}
          mountOnEnter
          unmountOnExit
        >
          <div className="OrderHistoryContainer">
            <div className="OrderListHeader">
              <img
                onClick={this.openOrderHistory}
                src={close}
                className="OrderListHeaderClose"
              />
              <span className="OrderListHeaderTitle">
                <Trans i18nKey={"Bank acccount"}></Trans>
              </span>
            </div>

            <div className="SettingItemsContainerx2" style={{paddingTop :"0px"}}>
 
              <div
                className="firstnamelastnameContainer emailcontainer"
                style={{ height: "56px", marginTop: "10px" }}
              >
                <p className="LP_PhoneNumberLabel">
                  <Trans i18nKey={"Bank Name"}> </Trans>{" "}
                </p>
                <div
                  className={`PhoneNumberContainer `}
                  style={{ height: "32px", borderRadius: "8px" }}
                >
                  <input
                    type="text"
                    placeholder={this.props.t("Ex. ABC Bank")}
                    className="emailinputregister"
                    value={this.state.BankName}
                    onChange={(e) => {
                      this.inputOnchange("BankName", e.target.value);
                    }}
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: "300",
                    }}
                  />
                </div>
              </div>
 
      <div
                className="firstnamelastnameContainer emailcontainer"
                style={{ height: "56px", marginTop: "10px" }}
              >
                <p className="LP_PhoneNumberLabel">
                  <Trans i18nKey={"Sort Code/Swift Code/BIC"}> </Trans>{" "}
                </p>
                <div
                  className={`PhoneNumberContainer `}
                  style={{ height: "32px", borderRadius: "8px" }}
                >
                  <input
                    type="text"
                    placeholder={this.props.t("Ex. ABCDEFG1HIJ")}
                    className="emailinputregister"
                    value={this.state.BankCode}
                    onChange={(e) => {
                      this.inputOnchange("BankCode", e.target.value);
                    }}
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: "300",
                    }}
                  />
                </div>
              </div>
                   <div
                className="firstnamelastnameContainer emailcontainer"
                style={{ height: "56px", marginTop: "10px" }}
              >
                <p className="LP_PhoneNumberLabel">
                  <Trans i18nKey={"Account Number/IBAN"}> </Trans>{" "}
                </p>
                <div
                  className={`PhoneNumberContainer `}
                  style={{ height: "32px", borderRadius: "8px" }}
                >
                  <input
                    type="text"
                    placeholder={this.props.t("Ex. AB01234500000006789111")}
                    className="emailinputregister"
                    value={this.state.AccountNumber}
                    onChange={(e) => {
                      this.inputOnchange("AccountNumber", e.target.value);
                    }}
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: "300",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="SettingFooter">
              <span
                style={{
                  backgroundImage: canSave && `linear-gradient(to top,${global.config.colors.primary}, ${global.config.colors.primaryLight})`,
                  color: canSave && global.config.colors.primaryText
                }}
                className={`SettingFooterButton ${!canSave && "DeactiveSettingFooterButton"
                  }`}
                onClick={canSave && this.saveChangePassword}
              >
                <Trans i18nKey={"Save"}></Trans>
              </span>
            </div>
          </div>
        </Slide>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.Settings.SettingsOpenDialoge,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
